import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=443b37e6"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443b37e6')) {
      api.createRecord('443b37e6', component.options)
    } else {
      api.reload('443b37e6', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=443b37e6", function () {
      api.rerender('443b37e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/alert/Modal.vue"
export default component.exports